export const TOKEN_COOKIE_NAME = 'wisory_user_token'
